/* eslint-disable @typescript-eslint/no-explicit-any */
import { OptionsMenuStorybook } from "@finanedi.es/storybook"
import { faCheck } from "@fortawesome/pro-light-svg-icons"
import { GetFacturasAceptablesDtoProps } from "api/DTOs/GetFacturasAceptablesDto"
import { GetPagaresAceptablesDtoProps } from "api/DTOs/GetPagaresAceptablesDto"
import { ESTADO_VERIFICACION_EFECTO } from "api/Types/EstadoVerificacionEfecto"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import { EstadoFinanciacionActual } from "../components/EstadoFinanciacionActual"

interface FinanciacionColumnsProps {
  t: TFunction
  handleRedirectToDetail: (
    rowData: GetFacturasAceptablesDtoProps[] | GetPagaresAceptablesDtoProps[]
  ) => void
  isContactoPage?: boolean
}

export const FINANCIACION_COLUMNS = ({
  t,
  handleRedirectToDetail,
  isContactoPage = false,
}: FinanciacionColumnsProps) => {
  const columns = [
    {
      key: "numero",
      header: `${t("validaciones.financiable.table.numberEfectHeader")}`,
      field: "numero",
      style: { width: "10" },
    },
    ...(isContactoPage
      ? []
      : [
          {
            key: "librador.razonSocial",
            header: `${t("validaciones.financiable.table.nameCompanyHeader")}`,
            field: "librador.razonSocial",
          },
          {
            key: "librador.nif",
            header: `${t("validaciones.financiable.table.nifHeader")}`,
            field: "librador.nif",
          },
        ]),
    {
      key: "fechaEmision",
      header: `${t("validaciones.financiable.table.dataEmisionHeader")}`,
      field: "fechaEmision",
      style: { width: "10" },
      body: ({
        fechaEmision,
      }: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
    },
    {
      key: "estado",
      header: `${t("validaciones.cesiones.table.columns.estado")}`,
      field: "estado",
      style: { width: "10" },
      alignCol: "center",
      body: EstadoFinanciacionActual,
    },
    {
      key: "importe",
      header: `${t("validaciones.financiable.table.importHedaer")}`,
      field: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({
        importe,
      }: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps) =>
        frontendCurrency(importe ?? 0),
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      alignCol: "right",
      body: (
        rowData: GetFacturasAceptablesDtoProps | GetPagaresAceptablesDtoProps
      ) => {
        if (!rowData.id) return null
        const optionDisabled = !(
          ESTADO_VERIFICACION_EFECTO.PENDIENTE === rowData.estado ||
          ESTADO_VERIFICACION_EFECTO.COMUNICADO === rowData.estado
        )
        return (
          <OptionsMenuStorybook
            id={rowData.id}
            items={[
              {
                title: `${t(
                  "validaciones.financiable.table.acceptFinanciacion"
                )}`,
                hasRedirect: true,
                action: () => {
                  handleRedirectToDetail([rowData])
                },
                disabled: optionDisabled,
                icon: faCheck,
              },
            ]}
            disabled={optionDisabled}
            position='right'
          />
        )
      },
    },
  ]
  return columns
}
